// extracted by mini-css-extract-plugin
export default {"page":"MenuPage_page__9y5sT","itemsContainer":"MenuPage_itemsContainer__mY6b5","bannerPage":"MenuPage_bannerPage__FQR4K","heading":"MenuPage_heading__ynZcP"};